import { SvgIcon } from "@components/common"

interface Props {
  onRetry: () => void
}

// BUG4 fix: `isFetchError` was already being SET (useFetchTeeUps.ts's catch block) but never
// READ anywhere -- a failed list fetch left `teeUps` at [] with `isLoading` false, which fell
// straight into the Empty-state branch (the same loading-vs-empty conflation QJ reported, just
// on the error path instead of the loading path). This gives the error path its own treatment
// instead of silently reading as "no TeeUps".
const FetchError = ({ onRetry }: Props) => (
  <div className="overflow-x-hidden flex flex-col items-center justify-center gap-4 text-center fixed top-1/2 left-1/2 xs:-translate-x-1/2 md:-translate-x-1/3 -translate-y-1/2 animate-fade min-w-[300px]">
    <SvgIcon name="loader" className="!w-auto !h-auto mb-2" />
    <h4 className="text-neutral-700 text-xl font-bold leading-7">
      Couldn&apos;t load your TeeUps
    </h4>
    <p className="text-neutral-500 text-base font-medium leading-normal">
      Something went wrong reaching the server.
    </p>
    <button
      type="button"
      data-testid="teeup-list-retry"
      onClick={onRetry}
      className="text-blue-500 text-base font-semibold leading-normal underline">
      Try again
    </button>
  </div>
)

export default FetchError
